import styled, { css, keyframes } from 'styled-components';
import { lFColor, lFColor2 } from 'pages/components/LFHeader/LFHeader.styled';
import { overlayZIndex } from '../Modal/Modal.styled';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

/** Full-bleed overlay; layout alerts sit above this in z (no Y gap). */
export const Root = styled.div<{ $instant?: boolean }>`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100svh;
  z-index: ${overlayZIndex + 100};
  pointer-events: auto;
  ${({ $instant }) => ($instant ? '' : css`animation: ${fadeIn} 0.15s ease-out;`)}
`;

export const Bg = styled.div<{ isSticky?: boolean }>`
  position: absolute;
  inset: 0;
  background: rgba(33, 33, 55, 0.72);
`;

export const Progress = styled.div`
  position: absolute;
  z-index: 1;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  min-width: 120px;
  padding: 22px 28px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(33, 33, 55, 0.18);
  color: ${lFColor};
`;

export const SpinnerWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${lFColor};
`;

/** Border spinner: rotate-only (composited), fixed stroke — avoids MUI dash-array jank/thinning. */
export const Spinner = styled.div`
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 4px solid rgba(33, 33, 55, 0.14);
  border-top-color: currentColor;
  animation: ${spin} 0.75s linear infinite;
  will-change: transform;
`;

export const Message = styled.div`
  font-family: Poppins, sans-serif;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: ${lFColor2};
  text-align: center;
  max-width: 200px;
  line-height: 1.35;
`;
